/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PharmacyOperatorRegistrableTypename = "PharmacyOperatorRegistrable" as const;

/**
 *
 * @export
 * @interface PharmacyOperatorRegistrable
 */
export interface PharmacyOperatorRegistrable {
  /**
   *
   * @type {number}
   * @memberof PharmacyOperatorRegistrable
   */
  chainId: number;
  /**
   *
   * @type {string}
   * @memberof PharmacyOperatorRegistrable
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyOperatorRegistrable
   */
  firstName: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyOperatorRegistrable
   */
  lastName: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyOperatorRegistrable
   */
  readonly __typename?: string;
}

export function PharmacyOperatorRegistrableFromJSON(json: any): PharmacyOperatorRegistrable {
  return PharmacyOperatorRegistrableFromJSONTyped(json, false);
}

export function PharmacyOperatorRegistrableFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyOperatorRegistrable {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyOperatorRegistrableTypename,

    chainId: json["chain_id"],
    email: json["email"],
    firstName: json["first_name"],
    lastName: json["last_name"],
  };
}

export function PharmacyOperatorRegistrableToJSON(object?: PharmacyOperatorRegistrable | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    chain_id: value.chainId,
    email: value.email,
    first_name: value.firstName,
    last_name: value.lastName,
  };
}
